import appAndPages from './app-and-pages'
import dashboard from './dashboard'
import formsAndTables from './forms-and-tables'
import uiElements from './ui-elements'

// Array of sections
export default [...dashboard, ...appAndPages, ...uiElements, ...formsAndTables]
